import iconOne from '../../assets/service/1.webp';
import iconTwo from '../../assets/service/2.webp';
import iconThree from '../../assets/service/3.webp';
import iconFour from '../../assets/service/4.webp';

const ServicesData = [
    {
        'icon': iconOne,
        'title': 'Dentures',
        'description': 'Lorem ipsum is placeholder text commonly used in the graphic,',
    },
    {
        'icon': iconTwo,
        'title': 'Implants',
        'description': 'Lorem ipsum is placeholder text commonly used in the graphic,',
    },
    {
        'icon': iconThree,
        'title': 'Whitening',
        'description': 'Lorem ipsum is placeholder text commonly used in the graphic,',
    },
    {
        'icon': iconFour,
        'title': 'Root Canal',
        'description': 'Lorem ipsum is placeholder text commonly used in the graphic,',
    }
]

export default ServicesData;